import { useState } from "react";
import { useIntl } from "react-intl";
import { ITextField } from "cayo.ui";
import { appSignals } from "@cayo/shared/components/App/utils";
import { showConfirmation } from "@cayo/shared/components/App/utils/showConfirmation";
import { showError } from "@cayo/shared/components/App/utils/showError";
import { LoadingType } from "@cayo/shared/components/GridContainer/types";
import { ILogger } from "@cayo/shared/libs/logger";
import { commonMessages } from "@cayo/shared/messages/common";
import { actionHandlers } from "@cayo/shared/scheme/actions";
import useService from "@cayo/shared/services/hooks/useService";
import { UIInteraction } from "./types";

const useUIInteraction = (log?: ILogger): UIInteraction => {
  const [loadingInfo, setLoading] = useState<string | boolean>(false);
  const actionBuilder = useService("actionBuilder");
  const intl = useIntl();

  return {
    loadingInfo,
    setLoading: (v: boolean | string | LoadingType) => {
      if ((v as LoadingType) === "submit") {
        v = intl.formatMessage(commonMessages.submittingData);
      }
      setLoading(v);
    },
    alertError: showError,
    confirm: (text, text2) => {
      return new Promise<boolean>((resolve) => {
        showConfirmation({
          confirmationMessage: text,
          confirmationMessage2: text2,
          onClose: resolve,
          showError: () => null,
        });
      });
    },
    prompt: (config) =>
      new Promise((resolve, reject) => {
        const fieldName = config.fieldName ?? "name";

        appSignals.send("showForm", {
          form: {
            title: config.title,
            actionBuilder,
            type: "json-form",
            description: config.text,
            items: [
              {
                label: config.fieldLabel ?? "Name",
                required: config.required ?? true,
                name: fieldName,
                defaultValue: config.initialValue ?? "",
                autoFocus: true,
                type: "text-field",
              } as ITextField,
            ],
            footer: {
              okText: config.okText ?? intl.formatMessage(commonMessages.ok),
              cancelText: config.cancelText ?? intl.formatMessage(commonMessages.cancel),
            },
            onSubmit: (object) => {
              log?.debug("Form onOk", object);
              resolve(object[fieldName] || "");
              return Promise.resolve();
            },
            onClose: (result) => {
              log?.debug("Form onClose", result);
              reject(new Error("Prompt cancelled"));
            },
          },
        });
      }),

    intl,
    actionHandlers: actionHandlers,
  };
};

export default useUIInteraction;
